import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, getPhotoCaptureContextId, photoCaptureUpdateContextDataAction, getPhotoCaptureIsTermsAndConditionAccepted, photoCaptureResetContextAction, photoCaptureUpdateTncAction, getPhotoCaptureFraudStatement, getPhotoCaptureFraudWarningAccept, getPhotoCapturePbeAsgTaskId, getPhotoCaptureAssignmentType, getPhotoCaptureIsFraudWarningApiStatus, getPhotoCaptureDisableLibrary, getHasEstimatorWorkflow, getPhotoCaptureVehicle, photoCaptureGetFraudWarningDataAction, photoCaptureUpdateFraudWarningAcceptAction, IntelligentScriptQuestionComponent } from "../../../domain/photoCapture";
import { getConfigurationDataAction } from "../../../domain/brandedNotification";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction } from "../../../domain/questionnaireEvaluation";
import { getGPCTheme } from '../selectors';
import { getGPCEvaluationDocId } from '../utilities';
const mapStateToProps = (state, ownProps) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        contextId: getPhotoCaptureContextId(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        fraudStatement: getPhotoCaptureFraudStatement(state),
        fraudWarningAccept: getPhotoCaptureFraudWarningAccept(state),
        pbeAsgTaskId: getPhotoCapturePbeAsgTaskId(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        isFraudWarningApiStatus: getPhotoCaptureIsFraudWarningApiStatus(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        hasEstimatorWorkflow: getHasEstimatorWorkflow(state),
        vehicle: getPhotoCaptureVehicle(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureResetContextAction,
        photoCaptureUpdateTncAction,
        photoCaptureGetFraudWarningDataAction,
        photoCaptureUpdateFraudWarningAcceptAction,
        getConfigurationDataAction
    }, dispatch);
};
export const ConnectedIntelligentScriptQuestion = connect(mapStateToProps, mapDispatchToProps)(IntelligentScriptQuestionComponent);
//# sourceMappingURL=ConnectedIntelligentScriptQuestion.js.map